/**
 *
 * IBM Confidential
 *
 * (C) Copyright IBM Corp. 2022, 2023
 *
 * The source code for this program is not published or otherwise
 * divested of its trade secrets, irrespective of what has been
 * deposited with the U. S. Copyright Office
 *
 * US Government Users Restricted Rights - Use, duplication or
 * disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
 *
 **/

import * as yup from 'yup';

import {
  AUTHENTICATION_METHODS,
  RESPONSE_METHODS,
  VALUE
} from '../catalog-openapi/constants';

const SEGMENT_API_URL = 'https://api.segment.io';
const SEGMENT_EVENT_PATH = '/v1/track';

// Although segment integration settings are specific instances of
// the custom extension integration settings, the settingsSchema is
// redefined here instead of using `BaseExtensionsSettingsSchema`
// because we have found some inconsistent behavior especially
// regarding how private.secrets spits out errors when concatting
// from the catalog-openapi's settingsSchema. Additionally, the
// default values for basic authentication's username and password
// values are changed and are specific to the Segment integration.
export const settingsSchema = yup.object().shape({
  private: yup.object().shape({
    secrets: yup.object().shape({
      authentication: yup.object().shape({
        basic: yup.object().shape({
          password: yup.object().shape({
            type: yup.string().default(VALUE),
            // Segment API mandates password to be an empty string.
            value: yup.string().default('')
          })
        })
      })
    })
  }),
  authentication: yup.object().shape({
    authentication_method: yup.string().default(AUTHENTICATION_METHODS.BASIC),
    basic: yup.object().shape({
      username: yup.object().shape({
        type: yup.string().default(VALUE),
        value: yup.string().required()
      })
    })
  }),
  catalog_item_id: yup.string(),
  server_url: yup.string().default(SEGMENT_API_URL),
  enabled_events: yup.array().of(
    yup.object().shape({
      name: yup.string()
    })
  ),
  path: yup.string().default(SEGMENT_EVENT_PATH),
  method: yup.string().default(RESPONSE_METHODS.POST)
});

export const FIELDS = {
  ENABLED_EVENTS: 'enabled_events',
  SEGMENT_WRITE_KEY: 'authentication.basic.username.value'
};
